import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import TermsOfUseContent from '../components/TermsOfUseContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
 
class TermsOfUse extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Terms Of Use"/>
                <TermsOfUseContent/>  
                <Footer/>
            </div>
       
        )
    }

}
export default TermsOfUse;